import API from "../services/apiservices";

async function getCodigo() {
  await API.getLocalDBDocument("representantesStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].codigo_repres;
    } else {
      return 0;
     }
  });
}


export default {
  namespaced: true,
  namespace: "representantesStore",

  state: {
    storename: "representantesStore",
    representantes: {
      codigo_repres: 0,
      api: null,
      data: [],
      error: null
    },
    emptyrepresentantes: {
      codigo_repres: 0,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({name: "representantesStore", route: "Servicos/Representantes/Get", setter: "setRepresentantes"}),
    gtxRepresentantes: (state) => state.representantes,
    gtxRepresentantes_data: (state) => state.representantes.data || [],
    gtxRepresentantes_GetById: (state) => (id) => state.representantes.data.find(f => f.codigo_repres == id) || {value: 0, text: ""},
    gtxRepresentantes_selected: (state, getters) => state.representantes.data.find(f => f.codigo_repres == getters.gtxRepresentantes_codigo),
    gtxRepresentantes_dataoptions: (state) => state.representantes.data ? state.representantes.data.map(o=>({value: o.codigo_repres, text: o.razao_social})).sort((a, b) => a.text.localeCompare(b.text)) : [],
    gtxRepresentantes_codigo_repres: (state) => state.representantes.codigo_repres,
    gtxRepresentantes_razaosocial: (state, getters) => {
      const data = state.representantes.data.find(f => f.codigo_repres == getters.gtxRepresentantes_codigo);
      return data ? data.razao_social : "";
    },
    gtxRepresentantes_error: (state) => state.representantes.error,
  },

  mutations: {
    setRepresentantes: (state, representantes) => (state.representantes = representantes && representantes.data && representantes.data.length > 0 ? {api: representantes.apiresponse, data: representantes.data, codigo: representantes.data[0].codigo_repres, error: null} : state.emptyrepresentantes),
    setRepresentantescodigo: (state, codigo) => (state.representantes.codigo_repres = codigo),
    setRepresentantesdata: (state, data) => (state.representantes.data = data),
  },

  actions: {
    actRepresentantesGet({ commit, getters }) {
      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", {StoreName: getters.gtxStore.name}, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                }).catch((error) => {
                  API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
                    if (doc && doc.data) {
                      commit(getters.gtxStore.setter, doc.data);
                      res(doc.data);
                    } else {
                      const emptyData = { data: [], codigo_repres: 0, error: error.message };
                      res(emptyData);
                    }
                  });
                });
              }
          });
          
        }).catch((error) => {
          API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
            if (doc && doc.data) {
              commit(getters.gtxStore.setter, doc.data);
              res(doc.data);
            } else {
              const emptyData = { data: [], codigo_repres: 0, error: error.message };
              res(emptyData);
            }
          });
        });
        } catch (err) {
          rej(err);
        }
      });

    },
    actRepresentantesMudaCodigo({ commit, getters }, codigo) {
      const data = getters.gtxRepresentantes_data.find(f => f.codigo_repres == codigo);
      if (data) {
        commit("setRepresentantescodigo", data.codigo_repres);
      }
    }
  },
};
